import api from './axiosInstance';
export const getAll = (params) => api.get('/prices', { params });
export const getHistory = (params) => api.get('/prices/history', { params });
export const getById = (id) => api.get(`/prices/${id}`);
export const create = (data) => api.post('/prices', data);
export const update = (id, data) => api.put(`/prices/${id}`, data);
export const remove = (id) => api.delete(`/prices/${id}`);
export const batchRemove = (ids) => api.post('/prices/batch-delete', { ids });
export const updateHistoryBasis = (historyId, data) => api.patch(`/prices/history/${historyId}`, data);
export const batchUpdate = (updates) => api.post('/prices/batch-update', { updates });
